import { Option } from "commander";

export const globalOptions = [
  new Option("-d, --debug", "debug mode").default(false, "off"),
  new Option(
    "-c, --cwd <cwd>",
    "the working directory. defaults to the current directory.",
  ).default("."),
];
